import { FC } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3.landing.EU1');

    return (
        <div id="dp3-teaser-EU1" className={`${css.thecomp} dp3-teaser-EU1 dp3-teaser-full`}>
            <p className="text">{t('text')}</p>
        </div>
    );
};

export default TheComp;
